export default "__VITE_ASSET__R0OsHJtD__"